export default __webpack_public_path__ + "static/media/MoonozCollege2.91d59ee6.jpg";